import { useQuery } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import { api, type ActiveTask } from '../lib/api'

const KIND_RU: Record<string, string> = {
  'node.auto_install':  'Установка пакетов',
  'node.reconcile':     'Синхронизация настроек',
  'site.create':        'Создание сайта',
  'site.update':        'Обновление сайта',
  'site.apply':         'Применение vhost',
  'site.delete':        'Удаление сайта',
  'site.backup':        'Бэкап сайта',
  'site.clone':         'Клонирование сайта',
  'cert.issue_le':      'Выпуск SSL',
  'cert.renew':         'Продление SSL',
  'cert.gen_csr':       'Генерация CSR',
  'db.create':          'Создание БД',
  'db.dump':            'Дамп БД',
  'db.import':          'Импорт БД',
  'ftp_user.create':    'Создание FTP',
  'features.install-web': 'Установка Nginx+PHP',
  'features.install-db':  'Установка MySQL',
  'features.install-ftp': 'Настройка SFTP',
}

export function ActiveTaskBadge({ nodeId, variant = 'inline' }: { nodeId: string; variant?: 'inline' | 'chip' }) {
  const { data } = useQuery({
    queryKey: ['node-active-task', nodeId],
    queryFn: async () => {
      try { return (await api.get<ActiveTask>(`/nodes/${nodeId}/active-task`)).data }
      catch { return null }
    },
    refetchInterval: 3000,
  })
  if (!data) return null
  const label = KIND_RU[data.kind] || data.kind
  const cls = variant === 'chip'
    ? 'inline-flex items-center gap-1.5 px-2 py-1 rounded-md bg-blue-50 border border-blue-200 text-blue-800 text-[12px] hover:bg-blue-100'
    : 'inline-flex items-center gap-1.5 text-[12px] text-blue-700 hover:text-blue-900 hover:underline'
  return (
    <Link to={`/tasks?highlight=${data.id}`} className={cls} onClick={e => e.stopPropagation()} title={data.kind}>
      <Spinner />
      <span>{label}{data.percent > 0 && data.percent < 100 ? ` · ${data.percent}%` : ''}</span>
    </Link>
  )
}

function Spinner() {
  return (
    <svg className="animate-spin w-3 h-3" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" className="opacity-25" />
      <path fill="currentColor" className="opacity-75" d="M4 12a8 8 0 018-8v3a5 5 0 00-5 5H4z" />
    </svg>
  )
}
